<div class="activation-component-wrapper">
  <activation-get-code
    (activation)="onActivation($event)"
    (changeState)="toggle($event)"
    *ngIf="activationState === 'confirmCode'"
    [userData]="userData"
  ></activation-get-code>
  <activation-get-phone
    (phone-update)="onActivation($event)"
    (changeState)="toggle($event)"
    *ngIf="activationState === 'updatePhone'"
    [userData]="userData"
  ></activation-get-phone>
</div>
